export default [
	'transitingPlanet',
	'progressedPlanet',
	'aspect',
	'natalPlanet',
	'houseEntry',
	'edit'
]